import * as React from 'react'
export const Nf = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.5 513 342" width="1em" height="1em" {...props}>
    <path fill="#FFF" d="M0 85.5h513v342H0z" />
    <path
      fill="#007b23"
      d="M0 85.5h171v342H0zm342 0h171v342H342zm-38 226.495-48-152.001-48 152.001h36v39.999h24v-39.999z"
    />
  </svg>
)
